import React, { useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import {
  Card
} from '@blueprintjs/core'
import { truncate } from 'lodash'
import { InsertFormClass } from '../classes'
import SyntaxHighlighter from 'react-syntax-highlighter'
// import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { atomOneLight } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import Editor from 'react-simple-code-editor'

const CodeRenderer = (codeString) => {
  return (<SyntaxHighlighter style={atomOneLight} customStyle={{ padding: 0 }}>
    {codeString}
  </SyntaxHighlighter>)
}

// -----------------------------------------------------------------------------------------------------------

function EditorBase ({ contentData, setContentData }) {
  // const [codeString, setCodeString] = useState(contentData)

  // useEffect(() => {
  //   if (contentData) {
  //     setCodeString(contentData)
  //   } else {
  //     setCodeString('')
  //   }
  // }, [contentData])

  // useImperativeHandle(ref, () => ({
  //   getCurrentContentData: () => {
  //     return codeString
  //   },
  //   clearCurrentEditor: () => {
  //     setCodeString('')
  //   },
  //   reset: () => {
  //     setCodeString(contentData)
  //   }
  // }), [codeString]
  // )

  return (
    <Editor
      padding={10}
      value={contentData || ''}
      highlight={CodeRenderer}
      onValueChange={setContentData}
      style={{
        fontFamily: 'monospace',
        fontSize: 16,
        minHeight: '100%',
        minWidth: '100%',
        paddingBottom: '30px',
        position: 'absolute'
      }}
      backgroundColor={atomOneLight.hljs.background}
    />
  )
}

function EditorMini ({ contentData, setContentData }) {
  return (
    <div css={css`width: var(--s8); height: var(--s7); position: relative; z-index: 10; overflow: auto;`}>
      <EditorBase contentData={contentData} setContentData={setContentData} />
    </div>
  )
}

const EditorBig = EditorBase
// eslint-disable-next-line no-func-assign
// EditorMini = forwardRef(EditorMini)
// -----------------------------------------------------------------------------------------------------------

function Render ({ contentData }) {
  return (<div css={css`min-width: 200px; min-height: 100px; font-size: 16px !important;`}><SyntaxHighlighter style={atomOneLight} customStyle={{ padding: 0 }}>
    {contentData || ''}
  </SyntaxHighlighter></div>)
}

const standardHeight = 60
function ThumbNailBase ({ contentData }) {
  // const [containerWidth, setContainerWidth] = useState(0)

  // 이 thumbnail의 container는 position: relative 같은 거여서 position: absolute의 기준이 될 수 있어야 함
  return (
    <React.Fragment>
      {/* <ResizeSensor onResize={(entries) => { */}
      {/*  const width = entries[0].contentRect.width */}
      {/*  // const height = e.contentRect.height */}
      {/*  setContainerWidth(width) */}
      {/*  // setContainerHeight(height) */}
      {/* }}> */}
      {/*  <div css={css`position: absolute; width: 80%; height: 0; appearance: none;`} /> */}
      {/* </ResizeSensor> */}
      <Card css={css`padding: 0; margin: 1px !important;
      max-height: ${standardHeight}px;
      min-width: ${standardHeight / 4}px;
      max-width: ${standardHeight * 4}px;
      overflow: hidden !important; font-weight: normal; font-size: 16px !important;
      & pre {
        overflow: hidden !important;
      }
    `} interactive>
        <SyntaxHighlighter style={atomOneLight} customStyle={{ padding: 0 }}>
          { // TODO separator가 '\n\n'라 문제가 발생하진 않나 확인하기
            contentData ? truncate(contentData, { length: 300, separator: '\n\n', omission: '' }) : ''}
        </SyntaxHighlighter>
      </Card>
    </React.Fragment>
  )
}

const ForCode = new InsertFormClass({
  typeName: 'Code',
  EditorMini,
  EditorBig,
  Render,
  ThumbNailBase
})

export default ForCode
